"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BrandLocaleList_1 = require("./locales/BrandLocaleList");
var BrandLocaleEditor_1 = require("./locales/BrandLocaleEditor");
var BrandLocalisations = /** @class */ (function (_super) {
    __extends(BrandLocalisations, _super);
    function BrandLocalisations(props) {
        return _super.call(this, props) || this;
    }
    BrandLocalisations.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AL = this.props.listAppLanguages.Subscribe("*", function (id, data) {
            _this.setState({ availLanguage: data.data });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            availLanguage: []
        }, function () {
            _this.props.listAppLanguages.LoadData();
        });
        this.props.state.setExtBreadCrumbPath(["Бренды", "Локализации брендов"]);
    };
    BrandLocalisations.prototype.componentWillUnmount = function () {
        this.props.listAppLanguages.UnSubscribe(this.SID_AL);
    };
    BrandLocalisations.prototype.onGoBackToTopPageClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    BrandLocalisations.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    BrandLocalisations.prototype.onEditClick = function (val) {
        this.setState({ edit_mode: "EDIT", record: val });
    };
    BrandLocalisations.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    BrandLocalisations.prototype.getBrandLocalisationRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(BrandLocaleEditor_1.default, { state: this.props.state, data: this.props.dataLocales, record: this.state.record, rootRecord: this.props.record, onGoBack: this.onGoBackClick.bind(this), availLanguage: this.state.availLanguage }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(BrandLocaleEditor_1.default, { state: this.props.state, data: this.props.dataLocales, record: this.state.record, rootRecord: this.props.record, onGoBack: this.onGoBackClick.bind(this), availLanguage: this.state.availLanguage }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(BrandLocaleList_1.default, { state: this.props.state, data: this.props.dataLocales, rootRecord: this.props.record, onGoBackClick: this.onGoBackToTopPageClick.bind(this), onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this) }));
        }
    };
    BrandLocalisations.prototype.render = function () {
        return (React.createElement("div", null, this.getBrandLocalisationRenderObject()));
    };
    return BrandLocalisations;
}(React.Component));
exports.default = BrandLocalisations;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/BrandLocalisations.tsx
// module id = 1812
// module chunks = 0